import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Scroll from "../Header/Scroll";
import Banner from "./components/Banner";
import Image2 from "../../assets/banner/banner12.jpg";
import About from "./components/About";
import Approach from "./components/Approach";
import CoreAreas from "./components/CoreAreas";
import CoreAreasMobile from "./components/CoreAreasMobile";
import Partners from "./components/Partners";
import banner1 from "../../assets/images/core.jpg";
import Impact from "./components/Impact";

const styles = {
  paperContainer: {
    height: 850,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styles2 = {
  paperContainer: {
    height: 1200,
    backgroundImage: `url(${banner1})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const Home = () => {
  return (
    <Box>
      <Helmet>
        <title> Homepage | Blue Echo Foundation</title>
      </Helmet>
      <Scroll>
        <AppBar position={"fixed"} elevation={0}>
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box display={{ xs: "none", sm: "block" }}>
        <Banner />
      </Box>
      <Box style={styles.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Banner />
      </Box>
      <Box>
        <Container>
          <About />
        </Container>
      </Box>
      <Box bgcolor={"#317ABE"}>
        <Impact />
      </Box>
      <Box>
        <Container>
          <Approach />
        </Container>
      </Box>
      <Box display={{ xs: "none", sm: "block" }}>
        <CoreAreas />
      </Box>
      <Box display={{ xs: "block", sm: "none" }} style={styles2.paperContainer}>
        <CoreAreasMobile />
      </Box>
      <Box>
        <Container>
          <Partners />
        </Container>
      </Box>
      <Box bgcolor={"#fff"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Home;
